import {
  BoldOutlined,
  ItalicOutlined,
  UnderlineOutlined,
  UnorderedListOutlined,
  OrderedListOutlined,
  LinkOutlined,
  PictureOutlined,
} from '@ant-design/icons'
import './blogEditor.scss'

const ContentToolbar = () => {

  return (
    <div id="content-toolbar" className="editor-toolbar" style={{ height: '50px' }}>
      {/* AI Button */}
      <button className="ai-btn">AI</button>

      {/* Title Dropdown */}
      <select className="ql-header toolbar-select" defaultValue="">
        <option value="1">Title</option>
        <option value="2">Subtitle</option>
        <option value="">Normal</option>
      </select>

      {/* Font Size */}
      <select className="ql-size toolbar-select">
        <option value="small">Small</option>
        <option value="">Normal</option>
        <option value="large">Large</option>
        <option value="huge">Huge</option>
      </select>

      {/* Formatting */}
      <button className="ql-bold"><BoldOutlined /></button>
      <button className="ql-italic"><ItalicOutlined /></button>
      <button className="ql-underline"><UnderlineOutlined /></button>

      <span className="divider" />

      <button className="ql-list" value="ordered">
        <OrderedListOutlined />
      </button>
      <button className="ql-list" value="bullet">
        <UnorderedListOutlined />
      </button>

      <button className="ql-link"><LinkOutlined /></button>
      <button className="ql-image"><PictureOutlined /></button>
    </div>
  )
}

export default ContentToolbar
